// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  margin: 0;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg);
  color: var(--color-text-muted);
  border-radius: var(--radius-md);
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color var(--duration-base) var(--easing-standard), color var(--duration-base) var(--easing-standard), border-color var(--duration-base) var(--easing-standard), transform var(--duration-base) var(--easing-standard);
  font-family: inherit;
}
.theme-toggle:hover {
  background-color: var(--color-bg-subtle);
  color: var(--color-primary);
  border-color: var(--color-primary);
}
.theme-toggle:active {
  transform: scale(0.94);
}
.theme-toggle:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}
.theme-toggle svg {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/component/theme/ThemeToggle.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,qCAAA;EACA,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,4OAAA;EAIA,oBAAA;AAFF;AAIE;EACE,wCAAA;EACA,2BAAA;EACA,kCAAA;AAFJ;AAKE;EACE,sBAAA;AAHJ;AAME;EACE,uCAAA;EACA,mBAAA;AAJJ;AAOE;EAAM,cAAA;AAJR","sourcesContent":[".theme-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  margin: 0;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg);\n  color: var(--color-text-muted);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background-color var(--duration-base) var(--easing-standard),\n              color var(--duration-base) var(--easing-standard),\n              border-color var(--duration-base) var(--easing-standard),\n              transform var(--duration-base) var(--easing-standard);\n  font-family: inherit;\n\n  &:hover {\n    background-color: var(--color-bg-subtle);\n    color: var(--color-primary);\n    border-color: var(--color-primary);\n  }\n\n  &:active {\n    transform: scale(0.94);\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--color-primary);\n    outline-offset: 2px;\n  }\n\n  svg { display: block; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
